import { ToRealAccountBannerStyled } from './styled/ToRealAccountBannerStyled';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import BinIcon from '../../../components/icon/Icon';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Slider } from '../../../components/Slider/Slider';
import { useCallback, useState } from 'react';
import { useTimer } from '../../../hooks/useTimer';
import { getUserAccounts } from '../../../app/appSelectors';
import _ from 'lodash';
import { ACCOUNT_TYPES } from '../../../app/appConstants';
import { setUserSelectedAccountCode } from '../../../app/appActions';
import { IAccountCode } from '../../../app/types/appReducer.t';
import { PUBLIC_URL } from '../../../config';
import BannerForwardButton from '../BannerForwardButton/BannerForwardButton';
import { getLiteTradeAccountMetrics } from '../../LiteTrade/liteTradeSelectors';
import { locationSlice } from "../../Location/locationReducer";
import { LOCATION_NAMES } from "../../Location/locationConstants";

interface IMobilePortfolioToRealAccountBannerProps {
    className?: string;
    showBanner?: boolean;
}

const BALANCE_AMOUNT_USD_TO_SHOW_SLIDER = 10;

function ToRealAccountBanner(props: IMobilePortfolioToRealAccountBannerProps) {
    const { className, showBanner } = props;
    const { getLangPath } = useLangContext();
    const [showSlider, setShowSlider] = useState(false);
    const accounts = useSelector(getUserAccounts);
    const metrics = useSelector(getLiteTradeAccountMetrics);
    const dispatch = useDispatch();

    const handleOpenSlider = useCallback(() => {
        if (metrics?.availableBalance < BALANCE_AMOUNT_USD_TO_SHOW_SLIDER) {
            setShowSlider(true);
        }
    }, [metrics]);

    const handleCloseSlider = useCallback(() => setShowSlider(false), []);

    const { startTimer: startTimerToOpenSlider } = useTimer(handleOpenSlider);

    const handleBannerClick = useCallback(() => {
        const liveAccount = _.find(accounts, { type: ACCOUNT_TYPES.LIVE });
        if (liveAccount) {
            dispatch(setUserSelectedAccountCode(liveAccount.name as IAccountCode));
            startTimerToOpenSlider(1000);
        }
    }, [accounts, dispatch, startTimerToOpenSlider]);

    const handleTopUpClick = useCallback(() => {
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.DEPOSIT }));
        handleCloseSlider();
    }, [dispatch, handleCloseSlider]);

    return <>
        {
            showBanner && <ToRealAccountBannerStyled onClick={handleBannerClick} className={className}>
                <div className={'d-flex flex-1 flex-column'}>
                    <h5 className={'mb-0'}>{getLangPath('banners.real_account.title')}</h5>
                    <span className={'description'}>
                    {getLangPath('banners.real_account.description')}
                </span>
                </div>
                <BannerForwardButton
                    color={'var(--color-button-primary-default)'}
                    background={'var(--color-fill-accent)'}
                />
            </ToRealAccountBannerStyled>
        }
        <Slider
            showCloseButton={false}
            placement={'bottom'}
            show={showSlider}
            onClose={handleCloseSlider}
            popUpClassName={'action-sheet'}
        >
            <div className={'d-flex flex-column'}>
                <div className={'d-flex justify-content-center'}>
                    <img src={`${PUBLIC_URL}/assets/deposit/coin-grey.png`} style={{ width: 56, height: 56 }}/>
                </div>
                <span className={'f20 text-center mt-2'}>
                    {getLangPath('banners.real_account.slider.title')}
                </span>
                <span className={'text-center mt-3'}>
                    {getLangPath('banners.real_account.slider.description')}
                </span>
                <Button variant={'primary'} onClick={handleTopUpClick} className={'mt-3'}>
                    <div className={'d-flex align-items-center justify-content-center'}>
                        <BinIcon name={'IcPlusCircle'} fill={'var(--color-tertiary)'}/>
                        <span className={'ms-1'}>{getLangPath('lite_version.home.top_up')}</span>
                    </div>
                </Button>
                <Button variant={'secondary'} onClick={handleCloseSlider} className={'mt-2'}>
                    {getLangPath('banners.real_account.slider.close')}
                </Button>
            </div>
        </Slider>
    </>;
}

export default ToRealAccountBanner;
